import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class ScrollService
{
    public scrollTo(element: HTMLElement, to: number, duration: number): void {
        if (duration <= 0) {
            return;
        }

        const difference = to - element.scrollTop;
        const self = this;

        setTimeout(function () {
            element.scrollTop = element.scrollTop + (difference / duration * 10);
            if (element.scrollTop === to) {
                return;
            }
            self.scrollTo(element, to, duration - 10);
        }, 10);
    }

    public scrollToTop(): void {
        // Determine the actual scrollable element based on layout type
        let scrollableElement: HTMLElement;

        // Check if we're in v2-layout (legacy mode) where .mat-sidenav-container is scrollable
        if (document.body.classList.contains('legacy-layout')) {
            const sidenavContainer = document.querySelector('.mat-sidenav-container') as HTMLElement;
            if (sidenavContainer) {
                scrollableElement = sidenavContainer;
            }
        }

        // If not legacy layout, check for .mat-sidenav-content (non-legacy v2-layout)
        if (!scrollableElement) {
            const sidenavContent = document.querySelector('.mat-sidenav-content') as HTMLElement;
            if (sidenavContent) {
                scrollableElement = sidenavContent;
            }
        }

        // Fall back to document body/documentElement for app-layout or other layouts
        if (!scrollableElement) {
            scrollableElement = document.hasOwnProperty('body') && document.body.hasOwnProperty('scrollTop')
                    ? document.body
                    : document.documentElement;
        }

        this.scrollTo(scrollableElement, 0, 1);
    }
}
